import { render, staticRenderFns } from "./AuthenticationSetting.vue?vue&type=template&id=22c212ba&"
import script from "./AuthenticationSetting.vue?vue&type=script&lang=js&"
export * from "./AuthenticationSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports